import i18n from "../../../../utils/i18n";
import classes from "./commonMoreBranch.module.scss";

const Radio = ({ checked }) => (
  <span
    className={`${classes.radio} ${checked ? classes.radioChecked : ""}`}
    aria-hidden="true"
  />
);

const BRANCH_OPTIONS = [
  {
    value: "singlecompany",
    title: i18n.t("searchflow.branchsingletitle"),
    subtitle: i18n.t("searchflow.branchsinglesubtitle"),
  },
  {
    value: "multiplecompany",
    title: i18n.t("searchflow.branchmultititle"),
    subtitle: i18n.t("searchflow.branchmultisubtitle"),
  },
];

const CommonMoreBranch = ({ moreBranchSelection, onMoreBranchChange }) => {
  return (
    <div className={classes.root}>
      <div className={classes.scrollArea}>
        <div className={classes.content}>
          <div className={classes.mainColumn}>
            <header className={classes.header}>
              <h1 className={classes.title}>
                {i18n.t("searchflow.branchtitle")}
              </h1>
            </header>

            <div className={classes.rightColumn}>
              <div className={classes.cardsContainer}>
                {BRANCH_OPTIONS.map((option) => {
                  const isSelected = moreBranchSelection === option.value;

                  return (
                    <button
                      key={option.value}
                      type="button"
                      className={`${classes.card} ${isSelected ? classes.selectedRow : ""}`}
                      onClick={() => onMoreBranchChange(option.value)}
                      aria-pressed={isSelected}
                    >
                      <div className={classes.cardContent}>
                        <div className={classes.cardTitle}>{option.title}</div>
                        <div className={classes.cardSubtitle}>{option.subtitle}</div>
                      </div>
                      <Radio checked={isSelected} />
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonMoreBranch;
